// extracted by mini-css-extract-plugin
export default {"glass":"Sizeup_glass__Ar6fr","titleBox":"Sizeup_titleBox__rQ8vm","singleColumnBox":"Sizeup_singleColumnBox__iuPh0","findcounselor":"Sizeup_findcounselor__OddJ7"};